import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 📝 راهنمای تعریف خانواده محصول جدید

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای کاربری

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 معرفی

در این فرم می‌توانید یک **خانواده محصول (BOM Family)** جدید تعریف کنید. یک خانواده محصول، نمایانگر کالبد و عنوان اصلی یک کالای تولیدی است که در آینده می‌تواند چندین نسخه و دستور ساخت (Revision) داشته باشد.

### مراحل ثبت:

1. **کد خانواده (کد انحصاری):** یک شناسه یکتا به انگلیسی وارد کنید. پیشنهاد می‌شود از سیستم کدگذاری استاندارد کارخانه (مثل `BOM-ENG-001`) استفاده کنید.
2. **نام خانواده:** عنوان تجاری یا فنی محصول را وارد نمایید (مثل `موتور احتراق داخلی V8`).
3. پس از تکمیل فیلدها، روی **«ثبت خانواده محصول»** کلیک کنید.

<Alert type="warning">
  کد خانواده پس از ثبت قابل تغییر نیست. دقت کنید که کد تخصیص داده شده با الگوی شناسه محصولات کارخانه مطابقت داشته باشد.
</Alert>
